$(document).ready(function() {
 // executes when HTML-Document is loaded and DOM is ready

  
// document ready  
});

